// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__2WEzq","footerWrapper":"footer_footerWrapper__hBagk"};